import { render, staticRenderFns } from "./DiagnosticHeader.vue?vue&type=template&id=176e3481&scoped=true"
import script from "./DiagnosticHeader.vue?vue&type=script&lang=js"
export * from "./DiagnosticHeader.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticHeader.vue?vue&type=style&index=0&id=176e3481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176e3481",
  null
  
)

export default component.exports